import { BaseGridItem } from 'shared/types/desktop-grid'

export const wouldCollide = (
  itemId: string,
  position: { row: number; col: number },
  size: { width: number; height: number },
  items: BaseGridItem[]
): boolean => {
  const targetCells = new Set<string>()
  // mark all cells that the target item would occupy
  for (let r = position.row; r < position.row + size.height; r++) {
    for (let c = position.col; c < position.col + size.width; c++) {
      targetCells.add(`${r},${c}`)
    }
  }
  // check if any other item occupies these cells
  return items.some(item => {
    if (item.id === itemId) return false // skip the item being moved
    for (
      let r = item.position.row;
      r < item.position.row + item.size.height;
      r++
    ) {
      for (
        let c = item.position.col;
        c < item.position.col + item.size.width;
        c++
      ) {
        if (targetCells.has(`${r},${c}`)) {
          return true // collision detected
        }
      }
    }
    return false
  })
}
